module.exports = __webpack_public_path__ + "static/media/striped_bar_preinspect.3519534d.svg";